/**
 * Server-reported cooldown countdown.
 *
 * The deadline always comes from the server (a resend cooldown, a rejection
 * cooldown); this hook only ticks it down so a button can be disabled without a
 * second round trip. A new value restarts the count.
 */

import { useEffect, useState } from 'react'

/**
 * Seconds left of a cooldown.
 *
 * Non-positive input disables the count entirely, which is how a state with no
 * cooldown is expressed.
 */
export function useCountdown(seconds: number): number {
  const [remaining, setRemaining] = useState(seconds)

  useEffect(() => {
    setRemaining(seconds)
  }, [seconds])

  useEffect(() => {
    if (remaining <= 0) {
      return
    }
    const timer = window.setInterval(() => {
      setRemaining((value) => (value <= 1 ? 0 : value - 1))
    }, 1000)
    return () => window.clearInterval(timer)
  }, [remaining])

  return remaining
}
